"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asMessage = exports.asSupportedArguments = exports.asAdjustedSignature = void 0;
const sanitizers_1 = require("@restless/sanitizers");
exports.asAdjustedSignature = (0, sanitizers_1.asObject)({
    account: sanitizers_1.asString,
    signature: sanitizers_1.asString,
});
exports.asSupportedArguments = (0, sanitizers_1.asObject)({
    skinContract: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    skinTokenId: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
});
exports.asMessage = (0, sanitizers_1.asObject)({
    intent: sanitizers_1.asString,
    expiry: sanitizers_1.asNumber,
    arguments: (0, sanitizers_1.asOptional)(exports.asSupportedArguments),
});
//# sourceMappingURL=asSignature.js.map